<template>
  <header class="page-header">
    <div class="page-header-main">
      <div v-if="icon" class="page-header-icon">
        <v-icon color="white">{{ icon }}</v-icon>
      </div>
      <div class="page-header-text">
        <h1 class="page-header-title">
          {{ title }}
          <span v-if="count !== null && count !== undefined" class="page-header-count">{{ count }}</span>
        </h1>
        <p v-if="subtitle" class="page-header-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div v-if="$slots.actions" class="page-header-actions">
      <slot name="actions"></slot>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    count: { type: [Number, String], default: null },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  margin-bottom: 20px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e3eee6;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.page-header-main {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.page-header-icon {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #14532d 0%, #15803d 55%, #16a34a 100%);
  box-shadow: 0 8px 20px rgba(21, 128, 61, 0.25);
}

.page-header-text {
  min-width: 0;
}

.page-header-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.3px;
  line-height: 1.25;
  color: #0f172a;
}

.page-header-count {
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(21, 128, 61, 0.1);
  color: #15803d;
  font-size: 13px;
  font-weight: 700;
}

.page-header-subtitle {
  margin: 2px 0 0;
  font-size: 14px;
  color: #64748b;
}

.page-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 600px) {
  .page-header {
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 14px;
  }

  .page-header-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
  }

  .page-header-title {
    font-size: 18px;
  }

  .page-header-subtitle {
    font-size: 13px;
  }

  .page-header-actions {
    width: 100%;
  }

  .page-header-actions > * {
    flex: 1;
  }
}
</style>
